import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import webLogo from "../../assets/icons/webLogo.svg";
import cross from "../../assets/icons/meu_icons/1.svg";
import open from "../../assets/icons/meu_icons/2.svg";
import  close from "../../assets/icons/meu_icons/3.svg";
import "./Header2.css";
import { servicesData } from "../ServiceCard/service_data";

import service from "../../assets/icons/header icon/7.svg";
import about from "../../assets/icons/header icon/8.svg";
import home from "../../assets/icons/header icon/9.svg";
import contact from "../../assets/icons/header icon/10.svg";
import phoneIcon from "../../assets/icons/callIcon.svg";
import whatsappIcon from "../../assets/icons/Banner_icons/1.svg";

function Header2() {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);

  const mainServices = servicesData.slice(0, 4);

  const scrollToSection = (id) => {
    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const element = document.getElementById(id);
    if (!element) return;

    const header = document.querySelector(".sticky_headers");
    const offset = header ? header.offsetHeight : 0;

    const top =
      element.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  const goToSection = (id) => {
    if (window.location.pathname === "/") {
      scrollToSection(id);
    } else {
      navigate("/", {
        state: { scrollToId: id },
      });
    }

    setMenuOpen(false);
  };

  const goToServiceDetail = (id) => {
    navigate(`/service/${id}`);
    setMenuOpen(false);
    setServiceOpen(false);
  };

  return (
    <>
      <header className="header2">

        {/* LOGO */}
        <div className="logo_contain">
          <img src={webLogo} alt="" />
        </div>

        {/* DESKTOP NAV */}
        <div className="header_ul">
          <ul>

            <li onClick={() => goToSection("home")}>
              <img src={home} className="nav_icon" alt="" />
              Home
            </li>

            <li className="desktop_services_dropdown">
              <div
                className="desktop_services_title"
                onClick={() => goToSection("services")}
              >
                <img src={service} className="nav_icon" alt="" />
                Services
              </div>

              <div className="services_dropdown_menu">
                {mainServices.map((serviceItem) => (
                  <div
                    key={serviceItem.id}
                    className="dropdown_item"
                    onClick={() => goToServiceDetail(serviceItem.id)}
                  >
                    <span className="dropdown_item_icon_wrap">
                      <img
                        src={serviceItem.icon}
                        alt={serviceItem.title}
                        className="dropdown_item_icon"
                      />
                    </span>
                    <span>{serviceItem.title}</span>
                  </div>
                ))}
                <div className="dropdown_divider" />
                <div
                  className="dropdown_item dropdown_more"
                  onClick={() => goToSection("services")}
                >
                  View all Services
                </div>
              </div>
            </li>

            <li onClick={() => goToSection("about")}>
              <img src={about} className="nav_icon" alt="" />
              About Us
            </li>

            {/* DESKTOP CONTACT */}
            <li className="contact_dropdown">
              <img src={contact} className="nav_icon" alt="" />
              Contact

              <div className="dropdown_menu">

                <div
  className="dropdown_item"
  onClick={() => {
    window.location.href = "tel:+971521743345";
  }}
>
  <span className="dropdown_item_icon_wrap">
    <img src={phoneIcon} alt="Call" className="dropdown_item_icon" />
  </span>
  <span>Call Us</span>
</div>

                <div
                  className="dropdown_item"
                  onClick={() =>
                    window.open(
                      "https://wa.me/971521743345",
                      "_blank"
                    )
                  }
                >
                  <span className="dropdown_item_icon_wrap">
                    <img src={whatsappIcon} alt="WhatsApp" className="dropdown_item_icon whatsapp_white" />
                  </span>
                  <span>Get Free Quote</span>
                </div>

              </div>
            </li>

          </ul>
        </div>

        {/* RIGHT SIDE */}
        <div className="mobile_right">

          {/* CALL BUTTON */}
          <div className="callnow_btn_contain">
           <button
  onClick={() =>
    window.location.href = "tel:+971521743345"
  }
>
  <span className="call_pulse_dot"></span>
  Call Now
</button>
          </div>

          {/* MOBILE HAMBURGER */}
          <div
            className={`hamburger ${
              menuOpen ? "active" : ""
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

        </div>

      </header>

      {/* MOBILE MENU */}
      <div
        className={`mobile_menu ${
          menuOpen ? "show" : ""
        }`}
      >

        {/* TOP */}
        <div className="mobile_menu_top">

          <img src={webLogo} alt="" />

          <div
            className="close_menu"
            onClick={() => setMenuOpen(false)}
          >
            <img src={cross} alt="Close" className="menu_icons" />
          </div>

        </div>

        {/* MOBILE NAV */}
        <ul>

          <li onClick={() => goToSection("home")}>
            <img src={home} className="nav_icon" alt="" />
            Home
          </li>

          <li className="mobile_services_dropdown">
            <div
              className="mobile_services_title"
              onClick={() => setServiceOpen(!serviceOpen)}
            >
              <div className="services_left">
                <img src={service} className="nav_icon" alt="" />
                Services
              </div>

              <span className="dropdown_icon">
                <img
                  src={serviceOpen ? close : open}
                  alt=""
                  className="menu_icons"
                />
              </span>
            </div>

            <div
              className={`mobile_services_menu ${
                serviceOpen ? "show" : ""
              }`}
            >
              {mainServices.map((serviceItem) => (
                <div
                  key={serviceItem.id}
                  className="mobile_dropdown_item"
                  onClick={() => goToServiceDetail(serviceItem.id)}
                >
                  {serviceItem.title}
                </div>
              ))}
              <div
                className="mobile_dropdown_item"
                onClick={() => goToSection("services")}
              >
                View all Services
              </div>
            </div>
          </li>

          <li onClick={() => goToSection("about")}>
            <img src={about} className="nav_icon" alt="" />
            About Us
          </li>

          {/* MOBILE CONTACT */}
          <li className="mobile_contact_dropdown">

            <div
              className="mobile_contact_title"
              onClick={() =>
                setContactOpen(!contactOpen)
              }
            >

              <div className="contact_left">
                <img
                  src={contact}
                  className="nav_icon"
                  alt=""
                />
                Contact
              </div>

             <span className="dropdown_icon">
  <img
  src={contactOpen ? close : open}
  alt=""
  className="menu_icons"
/>
</span>

            </div>

            {/* DROPDOWN */}
            <div
              className={`mobile_contact_menu ${
                contactOpen ? "show" : ""
              }`}
            >

              <div
                className="mobile_dropdown_item"
                onClick={() =>
                  window.location.href = "tel:+971521743345"
                }
              >
                <span className="dropdown_item_icon_wrap">
                  <img src={phoneIcon} alt="Call" className="dropdown_item_icon" />
                </span>
                <span>Call Us</span>
              </div>

              <div
                className="mobile_dropdown_item"
                onClick={() =>
                  window.open(
                    "https://wa.me/971521743345",
                    "_blank"
                  )
                }
              >
                <span className="dropdown_item_icon_wrap">
                  <img src={whatsappIcon} alt="WhatsApp" className="dropdown_item_icon whatsapp_white" />
                </span>
                <span>Get Free Quote</span>
              </div>

            </div>

          </li>

        </ul>

      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          className="menu_overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Header2;